import _ from "lodash";
import { generateMasterVisitEntities } from "../RxV2Comp/masterVisitEntities";

// function bracketed(t) {
//   return t ? ` (${t})` : "";
// }

// export function getAlteredName(defaultName, alteredNameArray) {
//   let result = _.filter(
//     alteredNameArray,
//     (x) => x.originalName === defaultName
//   )[0]?.changedName;
//   return result === undefined ? defaultName : result;
// }

// function getExaminationSectionNames(namingConvention) {
//   if (!namingConvention) {
//     return {
//       mainTitle: "EXAMINATION",
//       subSectionsNames: {
//         observations: "Observations",
//         diagnosis: "Diagnosis",
//         notes: "Notes",
//       },
//     };
//   }

//   let sectionNames = {
//     mainTitle: getAlteredName("EXAMINATION", namingConvention.sectionName),
//     subSectionsNames: {
//       observations: getAlteredName(
//         "Observations",
//         namingConvention.subSectionName
//       ),
//       diagnosis: getAlteredName("Diagnosis", namingConvention.subSectionName),
//       notes: getAlteredName("Notes", namingConvention.subSectionName),
//     },
//   };

//   return sectionNames;
// }

// export function getExaminationDataFlow(entities, namingConvention) {
//   let examEntities = _.filter(entities, (x) => x.sectionName === "EXAMINATION");
//   let examNotes = _.filter(
//     examEntities,
//     (x) => x.subsectionName === "EXAMINATION_NOTES"
//   );
//   let examDiagnosisNotes = _.filter(
//     examEntities,
//     (x) => x.subsectionName === "DIAGNOSIS"
//   );

//   let examObservations = _.filter(
//     examEntities,
//     (x) => x.subsectionName === "OBSERVATIONS"
//   );

//   let sectionNames = getExaminationSectionNames(namingConvention);

//   return {
//     examEntities,
//     examNotes,
//     examDiagnosisNotes,
//     examObservations,
//     sectionNames,
//   };
// }

// export function getEntityDataWithImagingAndLabs(stateEntity, sectionName) {
//   let entities = _.filter(stateEntity, (x) => x.sectionName === sectionName);
//   if (entities.length === 0) return [];
//   /** merge IMAGING/LABS */
//   const __imgLabs = _.filter(entities, (x) => x.entityName === "IMAGING/LABS");

//   if (__imgLabs.length) {
//     let first = __imgLabs[0];
//     if (first.final) {
//       return entities;
//     }
//     let rest = __imgLabs.slice(1);

//     let imageLabsEntity = first;
//     imageLabsEntity.instructions +=
//       bracketed(imageLabsEntity.notes) +
//       ", " +
//       rest
//         .map(
//           (imgLabEntity) =>
//             imgLabEntity.instructions + bracketed(imgLabEntity.notes)
//         )
//         .join(", ");

//     imageLabsEntity.notes = "";
//     imageLabsEntity.final = true;
//     entities = _.filter(entities, (x) => x.entityName !== "IMAGING/LABS");

//     entities.push(imageLabsEntity);
//   }

//   return entities;
// }

// export function getSortedSubSectionNames(
//   mutatedEntity,
//   masterVisitEntities,
//   sectionName
// ) {
//   let subsections = _.uniq(_.map(mutatedEntity, "subsectionName"));
//   let whichSection = _.find(
//     masterVisitEntities,
//     (x) => x.sectionName === sectionName
//   );
//   let subsectionsList = whichSection.subsections;
//   subsections.sort((a, b) => {
//     let aIndex = _.findIndex(subsectionsList, (x) => x.subsectionName === a);
//     let bIndex = _.findIndex(subsectionsList, (x) => x.subsectionName === b);
//     return aIndex - bIndex;
//   });
//   return subsections;
// }

// export function getSubSectionListFromMasterEntity(
//   masterVisitEntities,
//   sectionName
// ) {
//   let whichSection = _.find(
//     masterVisitEntities,
//     (x) => x.sectionName === sectionName
//   );

//   return whichSection.subsections;
// }

const masterVisitEntities = generateMasterVisitEntities("<nonesuch>");

export const getSubsectionsOf = (section) => {
  return _.find(masterVisitEntities, (y) => y.sectionName === section)
    .subsections;
};

export const getEntitiesFor = (es, sectionName) => {
  return _.filter(es, (x) => x.sectionName === sectionName);
};

export const getEntitiesForSubsection = (es, subsectionName) => {
  return _.filter(es, (x) => x.subsectionName === subsectionName);
};

export const groupEntitiesBySubsection = (es, ss) => {
  const groups = [];
  for (let sec of ss) {
    const entities = _.filter(
      es,
      (x) => x.subsectionName === sec.subsectionName
    );
    groups.push({
      subsectionName: sec.subsectionName,
      entities,
    });
  }
  return groups;
};
